<template>
  <div class="gf-field" :class="{focused: open}">
    <div class="select-box select-multi">
      <ul class="select-value" @click="toggleOpen" ref="selectValue">
        <li v-if="componentValue==null || componentValue.length==0">
          <SelectDispPlain :option="{value: null, text: '(none)'}" mode="value" />
        </li>
        <li v-for="option in componentOptions || []">
          <component :is="'select-disp-'+(type || 'plain')" :option="option" mode="value" />
        </li>
      </ul>
      <div class="select-caret" @click="toggleOpen" ref="selectCaret" tabindex="0" @keyup.enter="toggleOpen">
        <i class="fa-solid fa-caret-down"></i>
      </div>
      <div class="select-list" v-if="open" ref="selectList">
        <ul>
          <li class="search">
            <input type="text" v-model="query" placeholder="search here" ref="selectSearch" />
          </li>
          <li v-if="optional" :class="{selected: isSelected(null)}" tabindex="0" @keyup="handleKeyUp($event, {value: null})">
            <SelectDispPlain :selected="isSelected(null)" :option="{value: null, text: '(none)'}" mode="list" @click="doSelect(null)"  />
          </li>
          <li v-for="option in visibleOptions || []" tabindex="0" @keyup="handleKeyUp($event, option)" :class="{selected: isSelected(option.value)}">
            <component :is="'select-disp-'+(type || 'plain')" :selected="isSelected(option.value)" :option="option" mode="list" @click="doSelect(option.value)" />
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { componentMixin } from './FormCommon'

export default {
  props: ["placeholder", "options", "type", "optional"],
  mixins: [componentMixin],
  data: ()=>({
    open: false,
    query: "",
  }),
  computed: {
    componentOptions() {
      var result=[];
      for(var value of this.componentValue || []) {
        var item=(this.options || []).find(opt=>opt.value==value) || null;
        if (item)
          result.push(item);
      }
      return result;
    },
    visibleOptions() {
      return (this.options || []).filter(opt=>{
        return true;
      });
    },
  },
  watch: {
    open() {
      this.$nextTick(()=>{
        this.$refs.selectSearch && this.$refs.selectSearch.focus();
      });
    },
  },
  methods: {
    toggleOpen(type, $event) {
      this.open=!this.open;
    },
    handleKeyUp($event, option) {
      if ($event.key=="Enter")
        this.doSelect(option.value);
    },
    bodyClickListener($event) {
      if (!this.$refs.selectList) {
        this.open=false;
      } else {
        var el=$event.target;
        while(el) {
          if (el==this.$refs.selectList ||
              el==this.$refs.selectValue ||
              el==this.$refs.selectCaret)
            break;
          el=el.parentNode;
        }
        if (!el)
          this.open=false;
      }
    },
    isSelected(value) {
      if (value==null) {
        return !this.componentValue || this.componentValue.length==0;
      } else {
        return (this.componentValue || []).some(opt=>opt==value)
      }
    },
    doSelect(value) {
      if (value==null) {
        this.componentValue=[];
      } else {
        this.componentValue=this.componentValue || [];
        var index=this.componentValue.findIndex(opt=>opt==value);
        if (index==-1)
          this.componentValue.push(value);
        else
          this.componentValue.splice(index, 1);
      }
    },
  },
  mounted() {
    this.bodyClickListenerBound=this.bodyClickListener.bind(this);
    document.body.addEventListener("click", this.bodyClickListenerBound);
  },
  destroyed() {
    document.body.removeEventListener("click", this.bodyClickListenerBound);
  },
}
</script>
